import {getMethod, postMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/companyRegistration', request)
}

async function post(request) {
    return await postMethod('/api/companyRegistration', request)
}

export {get, post}
